// extracted by mini-css-extract-plugin
export default {"statuslist__item":"StatusList_statuslist__item__dAWmc"};